import React, { Fragment, useState } from "react";

// Components
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTrigger,
  DialogClose,
} from "../../components/ui/dialog";
import interceptor from "../../hooks/intercepter";
import * as z from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../components/ui/form";
import { useNavigate } from "react-router-dom";
import Otp from "./Otp";

const FormSchema = z
  .object({
    email: z.string().min(1, "Email is required").email("Invalid email"),
    new_password: z
      .string()
      .min(1, "Password is required")
      .min(8, "Password must have 8 character"),
    confirm_password: z.string().min(1, "Password confirmation is required"),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    path: ["confirm_password"],
    message: "Password do not match",
  });

const ResetPassword = ({ setIsRestOpen, isResetOpen, userEmail }) => {
  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      email: userEmail,
      new_password: "",
      confirm_password: "",
    },
  });
  const naviagte = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isOtpOpen, setIisOtpOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const submitPasswordForm = (values) => {
    console.log(values);
    setLoading(true)
    interceptor
      .axiosPost("users/auth/reset-password", values, null)
      .then((res) => {
        setLoading(false)
        if (res.status === 200) {
          setIsOpen(false);
          setIsRestOpen(false);
        } else {
          console.log("error getting user : ", res);
        }
      })
      .catch((err) => {
        return err;
      });
  };
  return (
    <Fragment>
      <Dialog open={isResetOpen} onOpenChange={setIsRestOpen}>
        <DialogTrigger
          className="text-sm font-medium text-blue text-right"
          onClick={() => setIsRestOpen(true)}
        ></DialogTrigger>
        <DialogContent  notDisable={true}  className="bg-white ms:px-7 px-5 py-5 rounded-xl sm:max-w-lg max-w-sm">
          <DialogDescription>
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(submitPasswordForm)}
                className="flex flex-col gap-6"
              >
                <div className="flex flex-col gap-5 mt-10">
                  <h5 className="text-xl font-semibold capitalize">
                    Reset Password
                  </h5>
                  <div>
                    <FormField
                      control={form.control}
                      name="email"
                      render={({ field }) => (
                        <FormItem className="space-y-0">
                          <FormControl>
                            <Input
                            
                              className="text-sm font-medium text-dark bg-background w-full h-[3.063rem] px-5 rounded-xl border-none"
                              placeholder="Email.."
                              type="text"
                              disabled
                              {...field}
                            />
                          </FormControl>
                          <FormMessage className="text-red md:font-semibold mt-2 inline-block" />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div>
                    <FormField
                      control={form.control}
                      name="new_password"
                      render={({ field }) => (
                        <FormItem className="space-y-0">
                          <FormControl>
                            <Input
                              className="text-sm font-medium text-dark bg-background w-full h-[3.063rem] px-5 rounded-xl border-none"
                              placeholder="New Passwrod.."
                              type="password"
                              autoComplete="off"
                              {...field}
                            />
                          </FormControl>
                          <FormMessage className="text-red md:font-semibold mt-2 inline-block" />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div>
                    <FormField
                      control={form.control}
                      name="confirm_password"
                      render={({ field }) => (
                        <FormItem className="space-y-0">
                          <FormControl>
                            <Input
                              className="text-sm font-medium text-dark bg-background w-full h-[3.063rem] px-5 rounded-xl border-none"
                              placeholder="Confirm Passwrod.."
                              type="password"
                              {...field}
                            />
                          </FormControl>
                          <FormMessage className="text-red md:font-semibold mt-2 inline-block" />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div>
                    <Button size="sm" className="w-full md:px-12 px-9">
                      Submit
                      {loading && <svg aria-hidden="true" class="inline ml-4 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="gray" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="red" />
                      </svg>
                      }
                    </Button>
                  </div>
                </div>
              </form>
            </Form>
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default ResetPassword;
